export const LISTING_INTAKE_ERROR_MESSAGES: Record<string, string> = {
  LISTING_INTAKE_NOT_FOUND: 'Captação não encontrada. Ela pode ter sido removida.',
  LISTING_INTAKE_INVALID_TRANSITION: 'Esta captação mudou de situação enquanto você olhava. Recarregue a página para ver como ela está agora.',
  LISTING_INTAKE_DOCUMENT_NOT_FOUND: 'Este documento não faz parte da captação.',
  OWNER_DOCUMENT_ALREADY_EXISTS: 'Já existe um proprietário com este CPF/CNPJ.',
  HISTORY_UNAVAILABLE: 'O histórico está fora do ar e o acesso precisa ficar registrado. Tente de novo em instantes.'
}
